var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 683,
    viewBox: "0 0 421 683",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1376_66816",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 421,
    height: 683
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 421,
    height: 683,
    fill: "#123051"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1376_66816)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 421,
    height: 683,
    fill: "#F5CC3B"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 211,
    cy: 362,
    r: 190,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 211,
    cy: 362,
    r: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 211,
    cy: 362,
    r: 342,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsBg);
export default __webpack_public_path__ + "static/media/analyticsBg.ec993fab4960dc8023f65a52b6a0b7fe.svg";
export { ForwardRef as ReactComponent };